import { render, staticRenderFns } from "./CreateMahnungDialog.vue?vue&type=template&id=41589fb4&scoped=true"
import script from "./CreateMahnungDialog.vue?vue&type=script&lang=ts"
export * from "./CreateMahnungDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41589fb4",
  null
  
)

export default component.exports